// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>
    dispatch => {

        dispatch({
            data: claim,
            isCopied: true,
            type: actions.COPY_CLAIM_PARTS
        });

        dispatch(routerActions.replace('/claims/parts/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/copy-claim.js